import Hero from './sections/Hero';
import WhoItsFor from './sections/WhoItsFor';
import CollabFeatures from './sections/Features';

const CollaborativeMode = () => {
  return (
    <>
      <Hero />
      <WhoItsFor />
      <CollabFeatures />
    </>
  );
};

export default CollaborativeMode;
